import AppRouter from "./app/router/AppRouter";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import SplashCursor from "./components/common/animations/SplashCursor";
import { primaryColor } from "./utils/comon";

function App() {
  return (
    <div>
      {/* <SplashCursor COLOR={primaryColor()} RAINBOW_MODE={false} /> */}
      <AppRouter />
      <ToastContainer theme="colored" />
    </div>
  );
}

export default App;
